import React from "react";
import Title from "../../components/Title/Title";
import Auxiliary from "../../util/Auxiliary";
import { Row, Col } from "antd";
import ManhoursStatistic from "./Statistics/ManhoursStatistic";
import PassportStatistic from "./Statistics/PassportStatistic";
import ViolationStatistic from "./Statistics/ViolationStatistic";
import TrainingStatistic from "./Statistics/TrainingStatistic";
import ManpowerStatistic from "./Statistics/ManpowerStatistic";
import FitnessStatistic from "./Statistics/FitnessStatistic";
import RealtimeTap from "./Statistics/RealtimeTap";

const Dashboard = () => {
  return (
    <Auxiliary>
      <Title>Dashboard</Title>
      <Row gutter={20}>
        <Col md={12} xs={24}>
          <ManhoursStatistic />
        </Col>
        <Col md={12} xs={24}>
          <PassportStatistic />
        </Col>
        <Col  md={8} xs={24}>
          <ViolationStatistic />
        </Col>
        <Col  md={8} xs={24}>
          <TrainingStatistic />
        </Col>
        <Col  md={8} xs={24}>
          <ManpowerStatistic />
        </Col>
        <Col  md={8} xs={24}>
          <FitnessStatistic />
        </Col>
        <Col  md={16} xs={24}>
          <RealtimeTap />
        </Col>
      </Row>
      {/* <iframe width="100%" height={1600} src="https://app.powerbi.com/view?r=eyJrIjoiNGZkZDY0NGItZTFmOS00NDAxLWJmYzQtNjIzNzAwNzZiNDMxIiwidCI6IjM0YTczNDc5LWEyNTgtNDNiMC05M2RkLTU3YzMzMDFmMTc4NyIsImMiOjEwfQ%3D%3D" frameBorder={0} allowFullScreen={true}></iframe> */}
    </Auxiliary>
  );
};

export default Dashboard;
